export default __webpack_public_path__ + "static/media/news1.dc37d38f.jpeg";